<template>
  <div id="web-footer" class="container">
    <p>Copyright ©{{ new Date().getFullYear() }} Teva Pharma S.L.U.</p>
    <div>
      <ul>
        <li>
          <a target="_blank" href="/politica-de-privacidad.pdf">
            Política de privacidad
          </a>
        </li>
        <li>
          <a target="_blank" href="/aviso-legal.pdf">Aviso legal </a>
        </li>
        <li>
          <RouterLink to="/politica-cookies">Política de cookies</RouterLink>
        </li>
      </ul>
      <a
        target="_blank"
        href="/politica-privacidad-farmacovigilancia-informacion-medica-reclamaciones-calidad.pdf"
        class="farmacovigilancia"
      >
        Política de Privacidad de Farmacovigilancia, Información Médica y
        Reclamaciones de Calidad
      </a>
    </div>
  </div>
</template>

<style lang="sass">
.container {
  width: 100%;
  max-width: 100% !important;
  box-sizing: border-box;
  margin-inline: auto;
  padding-right: 19.8vw;
  padding-left: 19.8vw;
}
@media (max-width: 1800px) {
  .container {
    padding-right: 14vw;
    padding-left: 14vw;
  }
}
@media (max-width: 1440px) {
  .container {
    padding-right: 10vw;
    padding-left: 10vw;
  }
}
@media (max-width: 1340px) {
  .container {
    padding-right: 5%;
    padding-left: 5%;
  }
}
#web-footer {
    padding-block: 27px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    ul {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 32px;
    }
    p, a {
        font-family: 'TevaSans-Regular';
        color: #00547D;
        font-size: 15px;
    }
    .farmacovigilancia {
      text-align: right;
      display: block
    }
    @media (max-width: 800px) {
        flex-direction: column-reverse;
        ul {
            flex-direction: column;
            gap: 4px;
        }
        .farmacovigilancia {
          text-align: center;
        }
    }
}
</style>
